import { Grid } from "@mui/material";
import React from "react";
import OperationTransferHeader from "./home/header";
import OperationTransferTable from "./home/table";

const OperationTransfer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OperationTransferHeader />
      </Grid>
      <Grid item xs={12}>
        <OperationTransferTable />
      </Grid>
    </Grid>
  );
};

export default OperationTransfer;
